<template>
  <span v-if="entryFlags.length">
    <v-tooltip
      v-for="(entryFlag, index) in entryFlags"
      :key="index"
      location="bottom"
      nudge-bottom="15"
    >
      <template #activator="{ props }">
        <span v-bind="props" class="mx-1">
          <v-icon
            :color="entryFlag.iconColor"
            size="small"
            :icon="entryFlag.icon"
          ></v-icon>
        </span>
      </template>
      <span>{{ entryFlag.tooltipText }}</span>
    </v-tooltip>
  </span>
</template>
<script>
import { defineComponent, toRefs, computed } from "vue";
import gql from "fraql";
import { useTranslation } from "i18next-vue";

export default defineComponent({
  name: "AppShowEntryFeiFlags",
  props: {
    entityType: {
      type: String,
      required: true,
      validate(val) {
        return ["horse", "person"].includes(val);
      }
    },
    viewMode: {
      type: String,
      default: null,
      validate(val) {
        if (!val) return true;
        return ["masterlist"].includes(val);
      }
    },
    registrationHorse: {
      type: Object,
      default: null
    },
    registrationPerson: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    switch (props.entityType) {
      case "horse":
        return horseEntryFlags(props);
      case "person":
      default:
        return personEntryFlags(props);
    }
  },
  fragments: {
    registrationHorseFields: gql`
      fragment _ on RegistrationHorse {
        feiRegistrationMissing
        feiDocumentsMissing
      }
    `,
    registrationPersonFields: gql`
      fragment _ on RegistrationPerson {
        feiRegistrationMissing
      }
    `
  }
});

function horseEntryFlags(props) {
  const { t } = useTranslation();
  const { registrationHorse } = toRefs(props);
  const entryFlags = computed(() => {
    return [
      {
        tooltipText: t(
          "horses:appShowHorse.alert.missingFEILicence.tooltip",
          "FEI annual registration missing for horse"
        ),
        displayFlag:
          registrationHorse.value?.feiRegistrationMissing === true &&
          props.viewMode == "masterlist",
        icon: "$iconExclamationCircle",
        iconColor: "red"
      },
      {
        tooltipText: t(
          "horses:appShowHorse.alert.missingDocuments.tooltip",
          "Horse documents are missing or invalid"
        ),
        displayFlag: registrationHorse.value?.feiDocumentsMissing === true,
        icon: "$iconCopy",
        iconColor: "red"
      }
    ].filter(flag => flag.displayFlag);
  });

  return { entryFlags };
}

function personEntryFlags(props) {
  const { t } = useTranslation();
  const { registrationPerson } = toRefs(props);
  const entryFlags = computed(() => {
    return [
      {
        tooltipText: t(
          "people:appShowAthlete.alert.missingFEILicence.tooltip",
          "FEI annual registration missing for athlete"
        ),
        displayFlag:
          registrationPerson.value?.feiRegistrationMissing === true &&
          props.viewMode == "masterlist",
        icon: "$iconExclamationCircle",
        iconColor: "red"
      }
    ].filter(flag => flag.displayFlag);
  });

  return { entryFlags };
}
</script>
